import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      Kerem Karadeniz
 */
function Rename({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.FILE.';
    return (
        <>
            <div className="form-element">
                {t(label + 'FILE-PATH')}
                <TextInput action={action} inputName="filePath" variables={variables} setOpenVariable={setOpenVariable} filter="string" fieldType="string"
                    displayName={t(label + 'FILE-PATH')}/>
            </div>
            <div className="form-element">
                {t(label + 'NEW-NAME')}
                <TextInput action={action} inputName="fileName" variables={variables} setOpenVariable={setOpenVariable} filter="string" fieldType="string"
                    displayName={t(label + 'NEW-NAME')}/>
            </div>
        </>
    );
}
export default Rename;